import React, { Component } from "react";

import Modal from "../Modal/Modal";
import Form from "../Form/Form";

class EditSitemaps extends Component {
  state = {
    sitemaps: this.props.sitemaps.join(", ")
  };

  onSave = () => {
    const { sitemaps = "" } = this.state;
    this.props.onSave({ sitemaps });
  };

  render() {
    const { sitemaps } = this.state;

    return (
      <Modal
        narrow
        extraClassName="EditSitemaps"
        onCancel={this.props.onClose}
        onSave={this.onSave}
        saveText="Save"
        mode="edit"
        title="Sitemap URLs"
      >
        <Form>
          <div>
            <label>Sitemaps</label>
            <textarea
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              placeholder="Sitemap URLs"
              value={sitemaps}
              onChange={e => this.setState({ sitemaps: e.target.value })}
            />
          </div>
        </Form>
      </Modal>
    );
  }
}

export default EditSitemaps;



// WEBPACK FOOTER //
// ./src/components/LBUs/EditSitemaps.js